<template>
  <div class="supplier-edit-list">
    <el-form ref="form" :model="form" :rules="rules">
      <template v-for="(item, index) in form.tableData">
        <!-- 文本类要求 -->
        <div
          v-if="item.materialType === otherMaterialTypeDict.TEXT.value"
          :key="`item-${index}`"
          class="edit-card"
        >
          <div class="edit-card-head">
            <span
              class="edit-card-head__title"
              :class="{
                required:
                  item.isRequired ===
                  otherMaterialRequirementDict.REQUIRED.value
              }"
            >
              {{ item.materialName }}
            </span>
            <span class="edit-card-head__desc">{{ item.remark }}</span>
          </div>
          <div class="edit-card-body">
            <el-form-item
              :prop="'tableData.' + index + '.textarea'"
              :rules="
                item.isRequired === otherMaterialRequirementDict.REQUIRED.value
                  ? rules.textarea
                  : {}
              "
            >
              <el-input
                v-model="form.tableData[index].textarea"
                type="textarea"
                :rows="3"
                placeholder="请输入"
                maxlength="800"
                show-word-limit
              />
            </el-form-item>
          </div>
        </div>

        <!-- 附件类要求 -->
        <div
          v-if="item.materialType === otherMaterialTypeDict.ATTACHMENT.value"
          :key="`item-${index}`"
          class="edit-card"
        >
          <div class="edit-card-head">
            <span
              class="edit-card-head__title"
              :class="{
                required:
                  item.isRequired ===
                  otherMaterialRequirementDict.REQUIRED.value
              }"
            >
              {{ item.materialName }}
            </span>
            <span class="edit-card-head__desc">{{ item.remark }}</span>
          </div>
          <div class="edit-card-body">
            <el-form-item
              :prop="
                item.isRequired === otherMaterialRequirementDict.REQUIRED.value
                  ? 'tableData.' + index + '.attachmentGroupId'
                  : ''
              "
              :rules="
                item.isRequired === otherMaterialRequirementDict.REQUIRED.value
                  ? rules.attachmentGroupId
                  : {}
              "
            >
              <upload
                v-if="uploadMode === 'fileId'"
                :file-id-before.sync="form.tableData[index].attachmentGroupId"
                :props-data="{
                  uploadMode: 'fileId',
                  limit: 10
                }"
              >
                <span slot="tip">
                  支持：rar .zip .doc .docx .pdf
                  .jpg等，单个文件最大200M，最多上传10个
                </span>
              </upload>

              <upload
                v-else
                ref="uploadFile"
                :props-data="{
                  bizType: bizType,
                  attachmentType: 'sign_up_other_attachment',
                  groupIdBefore: form.tableData[index].attachmentGroupId,
                  limit: 10,
                  onCompleteDelete: () =>
                    (form.tableData[index].attachmentGroupId = ''),
                  onSuccess: groupId =>
                    (form.tableData[index].attachmentGroupId = groupId)
                }"
              >
                <span slot="tip">
                  支持：rar .zip .doc .docx .pdf
                  .jpg等，单个文件最大200M，最多上传10个
                </span>
              </upload>
            </el-form-item>
          </div>
        </div>
      </template>
    </el-form>

    <!--<el-button @click="validateForm">校验</el-button>-->
  </div>
</template>

<script>
import Upload from '@/components/common/Upload'
import { cloneDeep } from 'lodash'
import {
  otherMaterialRequirementDict,
  otherMaterialTypeDict
} from '@/dictionary/project/common'

/**
 * @Description: 供应商响应列表
 */
export default {
  name: 'SupplierEditList',

  components: { Upload },

  props: {
    table: {
      type: Array,
      default: () => []
    },

    // 附件上传的业务类型
    bizType: {
      type: String,
      default: ''
    },

    uploadMode: {
      type: String,
      default: 'groupId'
    }
  },

  data() {
    return {
      // 材料类型
      otherMaterialTypeDict,

      // 是否必填
      otherMaterialRequirementDict,

      form: {
        tableData: []
      },
      rules: {
        textarea: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        attachmentGroupId: [
          {
            required: true,
            message: '请上传附件',
            trigger: 'change'
          }
        ]
      }
    }
  },

  created() {
    const list = this.table.map(item => {
      // 如果是附件类型，则要将content转换为attachmentGroupId
      if (item.materialType === otherMaterialTypeDict.ATTACHMENT.value) {
        item.attachmentGroupId = item.content || ''
      } else {
        item.textarea = item.content || ''
      }
      return item
    })
    this.$set(this.form, 'tableData', list)
  },

  methods: {
    /**
     * 校验表单
     */
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            reject(new Error('请按要求填写内容'))
            return
          }

          resolve(valid)

          this.$emit('update:table', cloneDeep(this.form.tableData))
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-card {
  border: 1px solid $border-color;
  border-radius: 4px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  .edit-card-head {
    background: $grey-background-color;
    padding: 8px 16px;

    .edit-card-head__title {
      color: $text-color;
      @include text-bold;

      &.required {
        &::before {
          content: '*';
          color: $danger-color;
          margin-right: 4px;
        }
      }
    }

    .edit-card-head__desc {
      color: $fourth-text-color;
      margin-left: 8px;
    }
  }

  .edit-card-body {
    padding: 16px;
  }
}
</style>
